/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { PolicyDetailPageService } from '@pages/PolicyDetailPage/services';

const MODULE_NAME = 'profile.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<PolicyDetailPageService>(
    PolicyDetailPageService.displayName
  );
};

export const cancelPolicy = async (context: any, event: any) => {
  const currentState = 'CANCEL_POLICY';
  const method = 'cancelPolicy';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getCancelPolicyStatus(event?.payload);

      if (content) {
        return resolve({
          key: 'CANCEL_POLICY_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'CANCEL_POLICY_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'CANCEL_POLICY_ERROR',
        value: _msg,
      });
    }
  });
};
